<template>
    <BaseModal :title="title" @close="handleModal" :visible="true" size="extra-large" customClass="video__popup__box">
        <div v-if="activeTutorial">
            <div class="video__popup__block">
                <div class="video__popup__cover">
                    <div class="video__box__wrapper">
                        <div
                            style="position: relative; width: 100%; padding-bottom: 56.25%; height: 0; overflow: hidden; border-radius: 12px;">
                            <iframe :id="`videoIframe_${activeIndex + 1}`" :src="activeTutorial.video_url"
                                frameborder="0" allow="autoplay; encrypted-media" allowfullscreen
                                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>
                        </div>
                    </div>
                    <div class="video__static__text__wrapper">
                        <h4 class="title">{{ activeTutorial.title }}</h4>
                        <div class="divider__sepline"></div>
                        <div class="static__desc__wrapper">
                            <div v-for="(section, sIndex) in activeTutorial.sections" :key="sIndex">
                                <h5>{{ section.heading }}</h5>
                                <p v-for="(para, pIndex) in section.content" :key="pIndex" v-html="para"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BaseModal>
</template>

<script setup>
import { ref, computed } from 'vue';
import BaseModal from '../BaseModal.vue';
import { videoGuideTutorials } from '@/utils/assessmentGroups';

// eslint-disable-next-line
const emit = defineEmits(['close', 'saved']);

const props = defineProps({
    groupId: Number
})

const title = ``;

const showModal = ref(true);
const activeIndex = ref(0); // set default active index (you can pass this dynamically)

const activeTutorial = computed(() => videoGuideTutorials.find(tutorial => tutorial.groupId === props.groupId));

const handleModal = (action = 'close') => {
    if (action === 'close') {
        const iframe = document.getElementById(`videoIframe_${activeIndex.value + 1}`);
        if (iframe) {
            const src = iframe.src;
            iframe.src = '';
            iframe.src = src; // reset video
        }
    }
    showModal.value = false;
    emit(action);
};
</script>